import { Breadcrumb, Card } from "antd";
import moment from "moment";
import React, { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import ChequeService from "../../services/cheque.service";
import Loader from "../../components/loader";
import { NumericFormat, PatternFormat } from "react-number-format";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { amountFormat } from "../../services/common.service";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function MyChequeDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [accDetails, setAccDetails] = useState({});
  const { t } = useTranslation();
  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      chqIssuedByMeSummary(location.state);
      setAccDetails(location.state);
    }
  }, []);

  const chqIssuedByMeSummary = useCallback(async (details) => {
    try {
      setLoader(true);

      const response = await ChequeService.chqIssuedByMeDetails({
        fromDate: moment().format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
        accountNo: details?.accountNo,
        type: "issued",
      });
      if (response.status === 200) {
        console.log("details", details);
        setDataSource(response.data["data"]);
        setLoader(false);
      }
    } catch (error) {
      setDataSource([]);
      setLoader(false);
    }
  }, []);

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <Breadcrumb>
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/cheques")}>My Cheques</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>Cheques Details</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <h3 className="primary-title">Cheques Details</h3>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-10 col-lg-9 ">
          <Card
            className="mb-3 application-card"
            style={{ paddingTop: 15, paddingBottom: 15 }}
          >
            <div className="acc-details-header">
              <h6 style={{ margin: 0, marginBottom: 10 }}>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
                :{" "}
                <span>
                  {accDetails?.accountType} {accDetails?.accountNo}
                </span>
              </h6>
              <h6 style={{ margin: 0, marginBottom: 10 }}>
                Cheques: {accDetails?.totalNoOfCheques}
              </h6>
              <h6 style={{ margin: 0, marginBottom: 10 }}>
                <span>Total Value : </span>
                <span>
                  {amountFormat(accDetails?.totalChequeAmount || "-")}
                </span>
              </h6>
            </div>
            {accDetails?.shortFall && (
              <div className="mt-3" align="right" style={{ color: "red" }}>
                <span>
                  <AiOutlineInfoCircle
                    style={{ fontSize: 16, marginRight: 5 }}
                  />
                  Shortfall{" "}
                </span>

                <span>{amountFormat(accDetails?.shortFallAmount)}</span>
              </div>
            )}
          </Card>
        </div>
      </div>

      <div className="dashboard-accounts-wrapper">
        <Card
          className="table-body application-card"
          style={{ minHeight: 300, padding: "10px 20px", paddingTop: 0 }}
        >
          <div className="row tbl-column-header">
            <div className="col-2">Cheque no</div>
            <div className="col-2">Paid to</div>
            <div className="col-2">Bank details</div>
            <div className="col-2">Cheque status</div>
            <div className="col-2">Cheque date</div>
            <div className="col-2">{t("common.amount", { defaultValue: "Amount" })}</div>
          </div>
          {loader && <Loader />}

          {dataSource.chqDeposistedOrIssuedByMeDetails?.map((option, idx) => (
            <div className="row tbl-row-data">
              <div className="col-2 txt-bold">{option?.chequeNumber}</div>
              <div className="col-2">{option?.narration || "-"}</div>
              <div className="col-2">
                {option?.bankName}, {option?.branchName}
              </div>
              <div className="col-2 Unused">{option?.chequeStatus}</div>
              <div className="col-2">{option?.chequeDate}</div>
              <div className="col-2 txt-bold">
                {amountFormat(option?.chequeAmt)}
              </div>
            </div>
          ))}
        </Card>
      </div>

      {/* <div className="row">
        {dataSource.map((option, idx) => (
          <div key={idx} className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
            <Card className="mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <span >Cheque no: {option?.chequeNumber}</span>
                <span>{amountFormat(option?.chequeAmt)}</span>
              </div>
              <div className="mt-3">Paid to {option?.narration}</div>
              <p>
                {option?.bankName}, {option?.branchName}
              </p>
              <p className="Unused">
                {option?.chequeStatus} on {option?.chequeDate}
              </p>
            </Card>
          </div>
        ))}
      </div> */}
    </>
  );
}
